import React, { useRef, useEffect } from "react";
import ChatItem from "./ChatItem";

const ChatDialogueArea = ({ messages, chatId, brainId, onQuestionSent, setIsLoading }) => {
    const chatEndRef = useRef(null);

    const scrollToBottom = () => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    if (!messages || messages.length === 0) {
        return <div className="empty-message">Ask your question to get started</div>;
    }

    return (
        <div className="chat-dialogue-area">
            {messages.map((message, index) => (
                <ChatItem
                    key={message.message_id}
                    content={message}
                    isLast={index === messages.length - 1}
                    chatId={chatId}
                    brainId={brainId}
                    onQuestionSent={onQuestionSent}
                    setIsLoading={setIsLoading}
                />
            ))}
            <div ref={chatEndRef} />
        </div>
    );
};

export default ChatDialogueArea;
